export default "__VITE_ASSET__45780231__"